<script>
import { mapActions } from 'vuex'
import AppDivider from '@/components/AppDivider'
import AppLabel from '@/components/AppLabel'
import AppNotificacao from '@/components/mixins/AppNotificacao.vue'
import AppInputPerfil from '@/screens/portal/seguranca/components/AppInputPerfil.vue'
import MainHeader from '@/components/MainHeader'
import AppEndereco from '@/screens/portal/seguranca/components/AppEndereco'
import AppInputTelefone from '@/components/AppInputTelefone'
import { orgaosOptions } from '@/libs/constants/praticas/opcoesSelects'
import layoutPage from '@/components(new)/layout/LayoutBases/LayoutCentral/LayoutCentral.vue'

export default {
  components: {
    AppDivider,
    AppLabel,
    AppEndereco,
    MainHeader,
    AppInputPerfil,
    AppInputTelefone,
    layoutPage
  },
  mixins: [
    AppNotificacao
  ],

  beforeRouteEnter (to, from, next) {
    if (to.params.tipo === 'externo') {
      next()
    } else {
      to.meta.isPublic = false
      next()
    }
  },

  beforeRouteLeave (to, from, next) {
    from.meta.isPublic = true
    next()
  },

  data () {
    return {
      orgaosOptions,
      disableEndereco: false,
      maxLengthRazaoSocial: 200,
      maxLengthEmail: 200,
      maxLengthNome: 300,

      codigoEstadoIterpa: null,
      municipioIterpa: null,

      tipoChanged: false,
      isEdicao: false,

      usuario: {
        municipioPrefeitura: null,
        pessoa: {
          tipo: 'PF',
          pessoaFisica: {
            nome: '',
            cpf: ''
          },
          pessoaJuridica: {
            razaoSocial: '',
            cnpj: '',
            inscricaoEstadual: '',
            cnae: {
              codigo: '',
              nomeAtividade: ''
            },
            nomeFantasia: '',
            ramoAtuacao: ''
          },
          enderecoCorrespondencia: {
            id: null,
            logradouro: '',
            numero: null,
            semNumero: false,
            complemento: '',
            bairro: '',
            cep: '',
            municipio: {
              id: '',
              codigoEstado: ''
            }
          },
          emails: [],
          email: '',
          confirmaEmail: '',
          telefones: [],
          orgao: ''
        },
        perfis: []
      },
      idMunicipio: null,
      municipios: []
    }
  },

  async mounted () {
    if (!this.$store.state.auth.usuario) {
      await this.initializeUserState()
    }

    if (this.$route.params.cpfCnpj) {
      this.usuario = await this.findUsuarioByCpfCnpj(this.$route.params.cpfCnpj)
      this.usuario.pessoa.telefones = this.usuario.pessoa.telefones.map(item => item.numero)
      this.usuario.pessoa.email = this.usuario.pessoa.emails[0].dado
      this.usuario.pessoa.confirmaEmail = this.usuario.pessoa.emails[0].dado

      this.isEdicao = true
    } else {
      this.usuario.pessoa.telefones = []
    }

    if (this.usuario?.municipioPrefeitura) {
      this.idMunicipio = this.usuario?.municipioPrefeitura?.id
    }

    this.municipios = await this.findMunicipiosByEstadoAtual() || []
  },

  computed: {

    isExterno () {
      return this.$route.params.tipo === 'externo'
    },

    pessoa () {
      return this.usuario.pessoa
    },

    isPessoaJuridica () {
      return this.pessoa.tipo === 'PJ'
    },

    isPessoaFisica () {
      return this.pessoa.tipo === 'PF'
    },

    setPessoaTipo: {
      get () {
        return this.pessoa.tipo
      },
      set (value) {
        this.tipoChanged = true
        this.confirmBox(this.$messages.CADASTRO_ALTERAR_TIPO_PESSOA, this.$messages.TITULO_WARNING,
          async () => {
            if (value === 'PJ') {
              this.pessoa.pessoaFisica.cpf = ''
              this.pessoa.pessoaFisica.nome = ''
            } else {
              this.pessoa.pessoaJuridica.cnpj = ''
              this.pessoa.pessoaJuridica.razaoSocial = ''
              this.pessoa.pessoaJuridica.inscricaoEstadual = ''
              this.pessoa.pessoaJuridica.cnae.codigo = ''
              this.pessoa.pessoaJuridica.cnae.nomeAtividade = ''
              this.pessoa.pessoaJuridica.nomeFantasia = ''
              this.pessoa.pessoaJuridica.ramoAtuacao = ''
            }
            this.pessoa.email = ''
            this.pessoa.confirmaEmail = ''
            this.pessoa.tipo = value
            this.pessoa.enderecoCorrespondencia = {
              logradouro: '',
              numero: null,
              semNumero: false,
              complemento: '',
              bairro: '',
              cep: '',
              municipio: {
                id: '',
                codigoEstado: ''
              }
            }
            this.pessoa.telefones = []
            this.pessoa.orgao = ''
            this.usuario.perfis = []

            this.tipoChanged = false
            this.$refs.observer.reset()
          },
          () => { this.tipoChanged = false }
        )
      }
    },

    hasTecnicoMunicipal () {
      return this.usuario?.perfis?.find(perfil => perfil.codigo === 'TECNICO_MUNICIPAL')
    }
  },

  methods: {
    ...mapActions({
      cadastrarUsuario: 'usuario/cadastrarUsuario',
      findUsuarioByCpfCnpj: 'usuario/findUsuarioByCpfCnpj',
      findMunicipiosByEstadoAtual: 'municipios/findMunicipiosByEstadoAtualPromise',
      getUsuario: 'auth/getUsuario',
      setPermissoes: 'auth/setPermissoes'
    }),

    async initializeUserState () {
      try {
        const usuario = await this.getUsuario()
        if (usuario) {
          this.$store.commit('auth/SET_USUARIO', usuario)
          if (usuario.perfilSelecionado) {
            await this.setPermissoes()
          }
        }
      } catch (error) {
        console.error('Usuário não autenticado ou erro ao carregar dados do usuário')
      }
    },

    async buscarDados () {
      const cpfCnpj = this.usuario.pessoa.tipo === 'PF' ? this.usuario.pessoa.pessoaFisica.cpf
        : this.usuario.pessoa.pessoaJuridica.cnpj

      if (cpfCnpj) {
        const result = await this.findUsuarioByCpfCnpj(cpfCnpj)

        if (result) {
          if (this.usuario.pessoa.tipo === 'PF') {
            this.usuario.pessoa.pessoaFisica.cpf = ''
          } else {
            this.usuario.pessoa.pessoaJuridica.cnpj = ''
          }

          this.showNotificacao(
            this.$messages.TIPO_ERROR,
            this.$messages.TITULO_ERROR,
            'O usuário já está cadastrado.'
          )
          this.$refs.observer.reset()
        }
      }
    },

    async cadastrar () {
      // Atenção: workaround para contornar problema na validação do componente de telefone.
      delete this.$refs.observer.refs['$ignoreTelefone$']
      if (this.idMunicipio) {
        this.usuario.municipioPrefeitura = {id: this.idMunicipio}
      }
      if (await this.$refs.observer.validate()) {
        if (!this.isEdicao) {
          this.confirmBox(this.$messages.FINALIZAR_CADASTRO_USUARIO, this.$messages.TITULO_WARNING,
            async () => {
              this.usuario.pessoa.telefones = this.usuario.pessoa.telefones.map(item => ({ numero: item }))
              this.usuario.pessoa.emails = [{dado: this.usuario.pessoa.email}]

              await this.cadastrarUsuario({ usuario: this.usuario, isExterno: this.isExterno })

              this.showNotificacao(
                this.$messages.TIPO_SUCCESS,
                this.$messages.TITULO_SUCCESS,
                this.$messages.CADASTRO_USUARIO_SUCESSO
              )

              this.$router.push({
                name: this.isExterno ? 'login' : 'portalSeguranca/administradorAcesso'
              })
            },
            () => {}
          )
        } else {
          this.usuario.pessoa.telefones = this.usuario.pessoa.telefones.map(item => ({ numero: item }))
          this.usuario.pessoa.emails = [{dado: this.usuario.pessoa.email}]

          await this.cadastrarUsuario({ usuario: this.usuario, isExterno: this.isExterno })

          this.showNotificacao(
            this.$messages.TIPO_SUCCESS,
            this.$messages.TITULO_SUCCESS,
            this.$messages.EDICAO_CADASTRO_SUCESSO
          )

          this.$router.push({
            name: 'portalSeguranca/administradorAcesso'
          })
        }
      } else {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          this.$messages.PREENCHA_TODOS_CAMPOS
        )
      }
    },

    cancelar () {
      this.confirmBox(this.$messages.CANCELAR_CADASTRO, this.$messages.TITULO_WARNING,
        () => {
          this.$router.push({
            name: this.isExterno ? 'login' : 'portalSeguranca/administradorAcesso'
          })
        },
        () => {}
      )
    },

    isUsuarioInterno () {
      const codigoSetores = this.usuario.perfis.map(perfil => perfil.setor ? perfil.setor.codigo : '')
      return (this.isEdicao && !codigoSetores.includes('EXTERNO')) && !this.isExterno
    },

    toUpperCase (event) {
      if (this.isPessoaFisica) {
        this.pessoa.pessoaFisica.nome = this.pessoa.pessoaFisica.nome.toUpperCase()
      } else {
        this.pessoa.pessoaJuridica.razaoSocial = this.pessoa.pessoaJuridica.razaoSocial.toUpperCase()
        this.pessoa.pessoaJuridica.cnae.nomeAtividade = this.pessoa.pessoaJuridica.cnae.nomeAtividade.toUpperCase()
        this.pessoa.pessoaJuridica.nomeFantasia = this.pessoa.pessoaJuridica.nomeFantasia.toUpperCase()
        this.pessoa.pessoaJuridica.ramoAtuacao = this.pessoa.pessoaJuridica.ramoAtuacao.toUpperCase()
      }
    },

    justPerfilInterno (setores) {
      let has = true
      setores.forEach(setor => {
        if (setor.codigo !== undefined) {
          if ((setor.codigo === 'AGENDAMENTO' || setor.codigo === 'EXTERNO' || setor.codigo === 'PREFEITURA' || this.hasTecnicoMunicipal)) {
            has = false
          }
        }
      })

      return has
    },

    hasSomeOneExterno (setores) {
      let has = false
      setores.forEach(setor => {
        if (setor.codigo !== undefined) {
          if (setor.codigo === 'AGENDAMENTO' && setor.codigo === 'EXTERNO' && setor.codigo === 'PREFEITURA') {
            has = true
          }
        }
      })

      return has
    },

    resetEndereco () {
      const endereco = {
        bairro: '',
        cep: '',
        complemento: '',
        logradouro: '',
        municipio: {
          codigoEstado: '',
          id: ''
        },
        numero: null,
        semNumero: false
      }
      this.usuario.pessoa.enderecoCorrespondencia = endereco
    },

    perfilAdicionado (perfil) {
      if (
        this.usuario.perfis.length > 0 &&
        (perfil.codigo === 'AGENDAMENTO' || perfil.codigo === 'EXTERNO' || perfil.codigo === 'PREFEITURA') &&
        this.justPerfilInterno(this.usuario.perfis)
      ) {
        this.resetEndereco()
      }
    }

  }
}

</script>
<template>
  <validation-observer ref="observer" tag="form">
    <layout-page>
      <div class="content-route-view">
      <el-card class="card">
        <h1 v-if="!isEdicao">Cadastro de usuário</h1>
        <h1 v-else>Edição de usuário</h1>
        <el-row v-if="!isExterno" class="margin-top" type="flex" justify="start">
          <el-radio-group v-if="!tipoChanged" v-model="setPessoaTipo" :disabled="isEdicao">
            <el-radio-button label="PF">
              <i class="fal fa-user"></i> Pessoa Física
            </el-radio-button>
            <el-radio-button label="PJ">
              <i class="fal fa-building"></i> Pessoa Jurídica
            </el-radio-button>
          </el-radio-group>
        </el-row>
        <app-divider v-if="!isEdicao && !isExterno" label="Dados do usuário" />
        <el-row v-if="!isEdicao && !isExterno" class="margin-top-15" :gutter="30">
          <el-col :span="12">
            <app-input-perfil
              v-if="!tipoChanged"
              v-model="usuario.perfis"
              :usuarioTipo="pessoa.tipo"
              @perfilAdicionado="perfilAdicionado"
            />
            <div v-if="hasTecnicoMunicipal" class="margin-top-15">
              <validation-provider rules="required" v-slot="{ errors }">
                <app-label label="Prefeitura:" />
                <el-select
                  v-model="idMunicipio"
                  class="full-width input"
                  :class="{ erro: errors.length }"
                >
                  <el-option
                    v-for="municipio in municipios"
                    :key="municipio.id"
                    :label="municipio.nome"
                    :value="municipio.id"
                  />
                </el-select>
                <span class="help erro">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </el-col>
          <el-col :span="12" v-if="!isExterno && pessoa.tipo == 'PF'">
            <app-label label="Órgão:" :required="false"/>
            <el-select
              v-model="usuario.pessoa.orgao"
              class="full-width input"
              clearable
            >
              <el-option
                v-for="orgao in orgaosOptions"
                :key="orgao.id"
                :label="orgao.nome"
                :value="orgao.id"
              />
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <app-divider :label="pessoa.tipo == 'PF' ? 'Pessoa Física' : 'Pessoa Jurídica'" />
        </el-row>
        <el-row
          v-if="pessoa.tipo === 'PF'"
          :gutter="30"
          type="flex"
          key="pessoaFisica"
          class="margin-top-15"
        >
          <el-col class="boxInput" :span="12">
            <validation-provider mode="lazy" rules="required|cpf_cnpj" name="cadastroUsuario/cpf" v-slot="{ errors }">
              <app-label label="CPF:" :required="true" />
              <el-input
                v-model="pessoa.pessoaFisica.cpf"
                v-mask="['###.###.###-##']"
                class="input"
                :class="{ erro: errors.length }"
                :disabled="isEdicao"
                type="tel"
              />
              <span class="help erro">{{ errors[0] }}</span>
            </validation-provider>
          </el-col>
          <el-col class="boxInput" :span="12">
            <validation-provider mode="lazy" rules="required" name="cadastroUsuario/nome" v-slot="{ errors }">
              <app-label label="Nome completo:" :required="true" />
              <el-input
                v-model="pessoa.pessoaFisica.nome"
                class="input"
                :class="{ erro: errors.length }"
                :maxlength="maxLengthNome"
                @blur="toUpperCase"
              />
              <span class="help erro">{{ errors[0] }}</span>
            </validation-provider>
          </el-col>
        </el-row>
        <el-row
          v-else
          :gutter="30"
          type="flex"
          key="pessoaJuridica"
          class="margin-top-15"
        >
          <el-col class="boxInput" :span="12">
            <validation-provider mode="lazy" rules="required|cpf_cnpj" name="cadastroUsuario/cnpj" v-slot="{ errors }">
              <app-label label="CNPJ:" :required="true" />
              <el-input
                v-model="pessoa.pessoaJuridica.cnpj"
                v-mask="['##.###.###/####-##']"
                class="input"
                :class="{ erro: errors.length }"
                :disabled="isEdicao"
                @blur="buscarDados"
                suffix-icon="el-icon-search"
                type="tel"
              />
              <span class="help erro">{{ errors[0] }}</span>
            </validation-provider>
          </el-col>
          <el-col class="boxInput" :span="12">
            <validation-provider mode="lazy" rules="required" name="cadastroUsuario/razaoSocial" v-slot="{ errors }">
              <app-label label="Razão Social:" :required="true" />
              <el-input
                v-model="pessoa.pessoaJuridica.razaoSocial"
                class="input"
                :class="{ erro: errors.length }"
                :maxlength="maxLengthRazaoSocial"
                @blur="toUpperCase"
              />
              <span class="help erro">{{ errors[0] }}</span>
            </validation-provider>
          </el-col>
        </el-row>
        <el-row
          v-if="pessoa.tipo === 'PJ'"
          :gutter="30"
          class="margin-top-15"
        >
          <el-col class="boxInput" :span="12">
            <validation-provider mode="lazy" rules="required" name="cadastroUsuario/nomeFantasia" v-slot="{ errors }">
              <app-label label="Nome fantasia:" :required="true" />
              <el-input
                v-model="pessoa.pessoaJuridica.nomeFantasia"
                class="input"
                :class="{ erro: errors.length }"
                @blur="toUpperCase"
              />
              <span class="help erro">{{ errors[0] }}</span>
            </validation-provider>
          </el-col>
          <el-col class="boxInput" :span="12">
            <validation-provider mode="lazy" rules="required" name="cadastroUsuario/inscricaoEstadual" v-slot="{ errors }">
              <app-label label="Inscrição estadual:" :required="true" />
              <el-input
                v-model="pessoa.pessoaJuridica.inscricaoEstadual"
                class="input"
                :class="{ erro: errors.length }"
                @blur="toUpperCase"
              />
              <span class="help erro">{{ errors[0] }}</span>
            </validation-provider>
          </el-col>
        </el-row>
        <el-row
          v-if="pessoa.tipo === 'PJ'"
          :gutter="30"
          class="margin-top-15"
        >
          <el-col class="boxInput" :span="12">
            <app-label label="Código CNAE (subclasse):" :required="false" />
            <el-input
              v-model="pessoa.pessoaJuridica.cnae.codigo"
              class="input"
              v-mask="['##.##-#/##']"
            />
          </el-col>
          <el-col class="boxInput" :span="12">
            <app-label label="Nome da atividade conforme CNAE:" :required="false" />
            <el-input
              v-model="pessoa.pessoaJuridica.cnae.nomeAtividade"
              class="input"
              @blur="toUpperCase"
            />
          </el-col>
        </el-row>
        <div v-if="pessoa.tipo === 'PJ'">
          <el-row :gutter="30" class="margin-top-15">
            <el-col class="boxInput" :span="12">
              <app-label label="Ramo de atuação:" :required="false" />
              <el-input
                v-model="pessoa.pessoaJuridica.ramoAtuacao"
                class="input"
                @blur="toUpperCase"
              />
            </el-col>
            <el-col class="boxInput" :span="12">
              <validation-provider mode="lazy" rules="required|email" name="cadastroUsuario/email" v-slot="{ errors }">
                <app-label label="E-mail:" :required="true" />
                <el-input
                  v-model="pessoa.email"
                  class="input"
                  :class="{ erro: errors.length }"
                  :maxlength="maxLengthEmail"
                />
                <span class="help erro">{{ errors[0] }}</span>
              </validation-provider>
            </el-col>
          </el-row>
          <el-row :gutter="30" class="margin-top-15">
            <el-col class="boxInput" :span="12">
              <validation-provider mode="lazy" rules="required|email_confirmation:@cadastroUsuario/email" name="cadastroUsuario/emailConfirmacao" v-slot="{ errors }">
                <app-label label="Confirmar e-mail:" :required="true" />
                <el-input
                  v-model="pessoa.confirmaEmail"
                  class="input"
                  :class="{ erro: errors.length }"
                  :maxlength="maxLengthEmail"
                />
                <span class="help erro">{{ errors[0] }}</span>
              </validation-provider>
            </el-col>
            <el-col class="boxInput" :span="12">
              <app-input-telefone
                :telefones="usuario.pessoa.telefones"
                :requiredTelefones="true"
                :nomeAba="isEdicao ? 'editUser' : 'createUser'"
                :observer="this.$refs.observer"
              />
            </el-col>
          </el-row>
        </div>
        <div v-else>
          <el-row :gutter="30" class="margin-top-15">
            <el-col class="boxInput" :span="12">
              <validation-provider mode="lazy" rules="required|email" name="cadastroUsuario/email" v-slot="{ errors }">
                <app-label label="E-mail:" :required="true" />
                <el-input
                  v-model="pessoa.email"
                  class="input"
                  :class="{ erro: errors.length }"
                  :maxlength="maxLengthEmail"
                />
                <span class="help erro">{{ errors[0] }}</span>
              </validation-provider>
            </el-col>
            <el-col class="boxInput" :span="12">
              <validation-provider mode="lazy" rules="required|email_confirmation:@cadastroUsuario/email" name="cadastroUsuario/emailConfirmacao" v-slot="{ errors }">
                <app-label label="Confirmar e-mail:" :required="true" />
                <el-input
                  v-model="pessoa.confirmaEmail"
                  class="input"
                  :class="{ erro: errors.length }"
                  :maxlength="maxLengthEmail"
                />
                <span class="help erro">{{ errors[0] }}</span>
              </validation-provider>
            </el-col>
          </el-row>
          <el-row :gutter="30" class="margin-top-15">
            <el-col class="boxInput" :span="12">
              <app-input-telefone
                :telefones="usuario.pessoa.telefones"
                :requiredTelefones="true"
                :nomeAba="isEdicao ? 'editUser' : 'createUser'"
                :observer="this.$refs.observer"
              />
            </el-col>
          </el-row>
        </div>
        <app-endereco
          :endereco="usuario.pessoa.enderecoCorrespondencia"
          nomeAba="cadastroUsuario"
          :disabledFields="disableEndereco"
          :upperCaseApply="true"
          :codigoEstado="usuario.pessoa.enderecoCorrespondencia.municipio.codigoEstado"
          :municipio="usuario.pessoa.enderecoCorrespondencia.municipio"
        />
        <el-row type="flex" justify="start" class="margin-top footer">
          <el-button @click="cancelar" class="cancelarButton">
            <i class="fas fa-times"></i> Cancelar
          </el-button>
          <el-button type="primary" @click="cadastrar()">
            <i class="fas fa-check"></i> {{ !isEdicao ? 'Cadastrar' : 'Salvar' }}
          </el-button>
        </el-row>
      </el-card>
      </div>
    </layout-page>
  </validation-observer>
</template>

<style lang="scss">

  .card {
    margin: 0 3%;
    border-radius: 10px;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  }

  .footer {
    justify-content: space-between;
  }

  .cancelarButton:hover, .cancelarButton:focus {
    background-color:#fef0f0;
    color: #f56c6c;
    border-color: #fbc4c4;
  }

  .margin-top-15 {
    margin-top: 15px;
  }

  .content-route-view {
    padding: 15px 40px;
  }

  @media (max-width: 750px) {
    .el-row {
      display: flex;
      flex-direction: column;
    }

    .boxInput {
      width: 100%;
    }

    .footer {
      flex-direction: row !important;
    }
  }

  @media (max-width: 1256px) {
    .content-route-view {
      padding: 10px 0px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/screens/portal/seguranca/CadastroUsuario.vue